import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import heroImage from "../../../assets/img/hero/hand-apps.png";

import '../Home.css';
import { SmoothScrollButton } from '../../FormCommon/SmoothScroll';


const Hero = () => (
    <React.Fragment>
        <header className="page-header page-header-dark bg-gradient-primary-to-secondary">
            <div className="page-header-content py-6">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 aos-init aos-animate" data-aos="fade-up">
                        </div>
                        <div className="col-lg-6 d-lg-block aos-init aos-animate" data-aos="fade-up" data-aos-delay="50" style={{height: "50vh"}}>
                            <h1 className="page-header-title">Logistics you can rely on</h1>
                            <p className="page-header-text mb-5">End to end transport services for your most complex needs.</p>
                            <SmoothScrollButton
                                className="btn-teal btn-marketing rounded-pill lift lift-sm"
                                to="cta"
                                content={<React.Fragment><span>Find out More</span><FontAwesomeIcon icon={faArrowDown} className="ml-2" /></React.Fragment>}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </header>
    </React.Fragment>
);

export default Hero;
